import { formatSIMC, relativeTimeCompact } from './format.js';

const MAX_ITEMS = 20;

export function createFeed(container, { onOpenTx } = {}) {
  function render(store) {
    const items = [...store.payments].reverse().slice(0, MAX_ITEMS);

    if (!items.length) {
      container.innerHTML = `<div class="feed-empty">Aguardando o primeiro pagamento…</div>`;
      return;
    }

    container.innerHTML = items
      .map((p) => {
        const from = store.nodes.get(p.from)?.agent;
        const to = store.nodes.get(p.to)?.agent;
        const fromLabel = from ? `${from.emoji} ${from.name}` : p.from.slice(0, 8);
        const toLabel = to ? `${to.emoji} ${to.name}` : p.to.slice(0, 8);
        return `
          <div class="feed-item">
            ${fromLabel} → ${toLabel} · ${formatSIMC(p.value)} SIMC ·
            há <span data-ts="${p.timestamp ?? ''}">${relativeTimeCompact(p.timestamp)}</span> ·
            <button type="button" class="tx-link" data-tx-hash="${p.hash}">tx</button>
          </div>
        `;
      })
      .join('');
  }

  function tick() {
    container.querySelectorAll('[data-ts]').forEach((el) => {
      const ts = Number(el.getAttribute('data-ts'));
      if (ts) el.textContent = relativeTimeCompact(ts);
    });
  }

  container.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-tx-hash]');
    if (btn) onOpenTx?.(btn.dataset.txHash);
  });

  return { render, tick };
}
